import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    meta: { title: '首页-广州南沙弘达仓储有限公司' },
    component: () => import(/* webpackChunkName: "about" */ '../views/indexView.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: { title: '公司简介-广州南沙弘达仓储有限公司' },
    component: HomeView
  },
  {
    path: '/NewsList',
    name: 'NewsList',
    meta: { title: '最新动态-广州南沙弘达仓储有限公司' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsListView.vue')
  },
  {
    path: '/HelpList',
    name: 'HelpList',
    meta: { title: '帮助中心-广州南沙弘达仓储有限公司' },
    component: () => import(/* webpackChunkName: "about" */ '../views/HelpListView.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    meta: { title: '详细内容-广州南沙弘达仓储有限公司' },
    component: () => import(/* webpackChunkName: "about" */ '../views/DetailView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { title: '联系方式-广州南沙弘达仓储有限公司' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
  {
    path: '/searchList', 
         name: 'searchList',
    meta: { title: '内容搜索-广州南沙弘达仓储有限公司' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/SearchListView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '广州南沙弘达仓储有限公司';
  next()
})
export default router
